import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { insertDatasetData } from '../requests/dataset/insertDatasetData';

export const useInsertDatasetData = () => {
  const {
    state: { token },
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [response, setResponse] = useState<any>(undefined);
  const handleApiError = useApiErrorHandling();

  const insert = async (api: string, data: any, forceHeader?: string) => {
    let res;
    try {
      setIsLoading(true);
      setResponse(undefined);
      setError(undefined);
      res = await insertDatasetData(api, data, token, forceHeader);
      setResponse(res);

      return {
        response: res,
        error: null,
      };
    } catch (e) {
      if (e instanceof Error) setError(e);
      const errorHandlingRes = await handleApiError(e, false, (forceHeader) =>
        insert(api, data, forceHeader)
      );
      if (errorHandlingRes instanceof Error) {
        return {
          response: null,
          error: errorHandlingRes,
        };
      }
      return errorHandlingRes;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    response,
    insert,
  };
};
